import React from 'react';
import PropTypes from 'prop-types';
import FieldsList from './components/FieldsList';

import { FieldsProvider } from './FieldsContext';
import { FieldEditProvider } from './FieldEditContext';

const PageFieldsForm = () => {
  return (
    <FieldsProvider>
      <FieldEditProvider>
        <FieldsList />
      </FieldEditProvider>
    </FieldsProvider>
  );
};

PageFieldsForm.propTypes = {
  page: PropTypes.object.isRequired,
};

export default PageFieldsForm;
